import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, effect, ElementRef, input, output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ChatBody, ChatEvent } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { get } from 'lodash';
import { CardLoaderModule } from '../../card-loader/card-loader.module';
import { ChatConversationLoaderComponent } from '../../chat-bot/chat-conversation-loader/chat-conversation-loader.component';
import { ChatMessageComponent } from '../chat-message/chat-message.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, ChatMessageComponent, CardLoaderModule, ChatConversationLoaderComponent, NgComponentOutlet, NgTemplateOutlet],
  selector: 'iot-platform-ui-chat-body',
  templateUrl: './chat-body.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chat-body.component.scss']
})
export class ChatBodyComponent {
  body = input.required<ChatBody>();
  dispatchAction = output<ChatEvent>();

  @ViewChild('chatBody') chatBody!: ElementRef;

  constructor() {
    effect(() => {
      const body = this.body();
      if (body) {
        const timeout = setTimeout(() => {
          this.scrollHandler();
          clearTimeout(timeout);
        }, 100);
      }
    });
  }

  private scrollHandler() {
    if (this.chatBody) {
      const container = this.chatBody?.nativeElement;
      const scrollHeight: number = get(container, 'scrollHeight', 0);
      container.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}
